import React from "react";
import {
  Button,
  Grid,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  inputFieldRoot: {
    "& .Mui-focused": { color: "white" },
    "& .MuiFormLabel-root": { fontWeight: 500 },
    "& input" : {
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px #606060 inset',
        WebkitTextFillColor: '#fff',
      },}
  },
  inputName: {
    "& .MuiInput-underline:after": { borderBottom: "2px solid red" },
  },
  inputEmail: {
    "& .MuiInput-underline:after": { borderBottom: "2px solid yellow" },
  },
  inputMessage: {
    "& .MuiInput-underline:after": { borderBottom: "2px solid blue" },
  },
  submit: { margin: theme.spacing(3, 0, 2) },
}));

function Form(props) {
  const classes = useStyles();

  return (
    <div>
      <form style={{ marginTop: "2em" }} name="contact" method="POST" data-netlify="true">
        <input type='hidden' name='form-name' value='contact' />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              className={`${classes.inputFieldRoot} ${classes.inputName}`}
              required
              id="name"
              name="name"
              label="Your Name"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              className={`${classes.inputFieldRoot} ${classes.inputEmail}`}
              required
              name="email"
              label="Your Email Address"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              className={`${classes.inputFieldRoot} ${classes.inputMessage}`}
              required
              name="message"
              label="Your Message Here"
              fullWidth
              multiline={true}
              rowsMax={10}
            />
          </Grid>
          <div data-netlify-recaptcha="true"></div>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Submit
          </Button>
        </Grid>
      </form>
    </div>
  );
}

export default Form;
